import React from 'react';
import PropTypes from 'prop-types';
import { isNil, capitalize } from 'lodash';
import { Badge } from '@unite-us/app-components';

const StatusBadge = ({ status }) => {
  const commonClasses = 'leading-4 w-24';
  const statusText = capitalize(status);
  if (isNil(status)) {
    return <Badge text={statusText} className={commonClasses} color="#F4D316" />;
  }

  if (status.toLowerCase() === 'complete') {
    // tw color 'dark-green'
    return <Badge text={'Complete'} className={commonClasses} color="#078B00" />;
  }
  if (status.toLowerCase() === 'draft') {
    // tw color 'canary-yellow'
    return <Badge text={'Draft'} className={commonClasses} color="#F4D316" />;
  }
  if (status.toLowerCase() === 'declined') {
    // tw color 'red'
    return <Badge text={'Declined'} className={commonClasses} color="#D0021B" />;
  }

  if (status.toLowerCase() === 'outreach failed') {
    // tw color 'red'
    return <Badge text={'Outreach Failed'} className={commonClasses} color="#D0021B" />;
  }

  return null;
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusBadge;
